import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, KeepAlive as _KeepAlive, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-cabb126e"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "futures-container"
};
const _hoisted_2 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "justify-content": "start !important"
  }
};
const _hoisted_3 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_4 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
import FuturesView from '@/views/futures/FuturesView.vue'; //   import SecondView from '@/views/futures/SecondView.vue'

import CommoditiesView from '@/views/futures/CommoditiesView.vue';
import IndicesView from '@/views/futures/IndicesView.vue';
import { getUserAsset } from '@/apis';
import { ref, onActivated } from 'vue';
import { useI18n } from "vue-i18n";
import { useRoute } from 'vue-router'; //   import { useCounterStore } from '@/stores/counter'
//   const store = useCounterStore()

export default {
  __name: 'FuturesTab',
  emits: ["tabbarShowChange", "tabbarIndexChange"],

  setup(__props, {
    emit
  }) {
    const {
      t
    } = useI18n(); //   const router = useRouter()

    const route = useRoute();
    const activeIndex = ref(0);
    const assetUsdt = ref(0);

    const assetInit = async () => {
      const res = await getUserAsset({
        platform: 1
      });

      if (res.code === 200 && res.data) {
        res.data.forEach(item => {
          if (item.marketName === 'USDT') {
            assetUsdt.value = item.active ? item.active : 0;
          }
        });
      }
    };

    onActivated(() => {
      const paramActive = Number(route.query.active);

      if (paramActive != null) {
        activeIndex.value = paramActive;
        emit("tabbarIndexChange", 3);
      }
    });
    return (_ctx, _cache) => {
      const _component_van_tab = _resolveComponent("van-tab");

      const _component_van_tabs = _resolveComponent("van-tabs");

      const _component_van_nav_bar = _resolveComponent("van-nav-bar");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_nav_bar, {
        class: "futures-nb",
        "safe-area-inset-top": true,
        fixed: true,
        placeholder: true,
        "z-index": "200"
      }, {
        left: _withCtx(() => [_createVNode(_component_van_tabs, {
          class: "futures-nav-tab",
          ellipsis: false,
          active: activeIndex.value,
          "onUpdate:active": _cache[0] || (_cache[0] = $event => activeIndex.value = $event),
          style: {
            "--van-tabs-bottom-bar-width": "0px",
            "--van-tab-font-size": "18px",
            "--van-tab-text-color": "#898b8d",
            "--van-font-weight-bold": "700",
            "font-weight": "700"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_van_tab, {
            value: "0"
          }, {
            title: _withCtx(() => [_createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('contract')), 1)]),
            _: 1
          }), _createVNode(_component_van_tab, {
            value: "1"
          }, {
            title: _withCtx(() => [_createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('commodities')), 1)]),
            _: 1
          }), _createVNode(_component_van_tab, {
            value: "2"
          }, {
            title: _withCtx(() => [_createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('indices')), 1)]),
            _: 1
          })]),
          _: 1
        }, 8, ["active"])]),
        _: 1
      }), _createVNode(_component_van_tabs, {
        class: "tab-no-header",
        active: activeIndex.value,
        "onUpdate:active": _cache[1] || (_cache[1] = $event => activeIndex.value = $event)
      }, {
        default: _withCtx(() => [_createVNode(_component_van_tab, null, {
          default: _withCtx(() => [(_openBlock(), _createBlock(_KeepAlive, null, [_createVNode(FuturesView, {
            activeIndex: activeIndex.value,
            assetUsdt: assetUsdt.value,
            onAssetInit: assetInit
          }, null, 8, ["activeIndex", "assetUsdt"])], 1024))]),
          _: 1
        }), _createVNode(_component_van_tab, null, {
          default: _withCtx(() => [(_openBlock(), _createBlock(_KeepAlive, null, [_createVNode(CommoditiesView, {
            activeIndex: activeIndex.value,
            assetUsdt: assetUsdt.value,
            onAssetInit: assetInit
          }, null, 8, ["activeIndex", "assetUsdt"])], 1024))]),
          _: 1
        }), _createVNode(_component_van_tab, null, {
          default: _withCtx(() => [(_openBlock(), _createBlock(_KeepAlive, null, [_createVNode(IndicesView, {
            activeIndex: activeIndex.value,
            assetUsdt: assetUsdt.value,
            onAssetInit: assetInit
          }, null, 8, ["activeIndex", "assetUsdt"])], 1024))]),
          _: 1
        })]),
        _: 1
      }, 8, ["active"])]);
    };
  }

};